"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingId = exports.ILoginContent = exports.IFeatureFlags = exports.IOrgFeatureFlags = exports.IAppConfig = exports.IAppConfigs = void 0;
const openapi_1 = require("../../../openapi");
/** @deprecated use IFeatureFlags */
let IAppConfigs = class IAppConfigs {
};
IAppConfigs = __decorate([
    (0, openapi_1.ClassSchema)({
        additionalProperties: (0, openapi_1.ref)(() => IAppConfig),
    })
], IAppConfigs);
exports.IAppConfigs = IAppConfigs;
/** @deprecated use IOrgFeatureFlags */
let IAppConfig = class IAppConfig {
    enabled;
};
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], IAppConfig.prototype, "enabled", void 0);
IAppConfig = __decorate([
    (0, openapi_1.ClassSchema)({
        additionalProperties: { type: 'string' },
    })
], IAppConfig);
exports.IAppConfig = IAppConfig;
let IOrgFeatureFlags = class IOrgFeatureFlags {
};
IOrgFeatureFlags = __decorate([
    (0, openapi_1.ClassSchema)({ additionalProperties: { type: 'string' } })
], IOrgFeatureFlags);
exports.IOrgFeatureFlags = IOrgFeatureFlags;
class IFeatureFlags {
    names;
    values;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IFeatureFlags.prototype, "names", void 0);
__decorate([
    (0, openapi_1.Schema)({ additionalProperties: (0, openapi_1.ref)(() => IOrgFeatureFlags) })
], IFeatureFlags.prototype, "values", void 0);
exports.IFeatureFlags = IFeatureFlags;
class ILoginContent {
    logo;
    loginContentImageUrl;
    loginContentHtml;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uri', nullable: true })
], ILoginContent.prototype, "logo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uri', nullable: true })
], ILoginContent.prototype, "loginContentImageUrl", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', nullable: true })
], ILoginContent.prototype, "loginContentHtml", void 0);
exports.ILoginContent = ILoginContent;
var SettingId;
(function (SettingId) {
    SettingId["LoginContent"] = "logincontent";
})(SettingId = exports.SettingId || (exports.SettingId = {}));
